const initialState = {   
    transactionList: [],
    pageSize: 10,
    activePage: 1,
    orderBy: null,
    total_number: 0,
    serachFor: "",
    dateFrom: "",
    dateTo: "",

    sortBy: {"name": "Created", "id": 4},
    sortDirection: 1
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {

    case "MAP_TRANSACTION_SORT_DIRECTION":
        return{
            ...state,
            sortDirection: action.data
        }

    case "MAP_TRANSACTION_DATE_FROM":
        return{
            ...state,
            dateFrom: action.data
        }

    case "MAP_TRANSACTION_DATE_TO":
        return{
            ...state,
            dateTo: action.data
        }


    case "MAP_TRANSACTION_SEARCH_FOR":
        return{
            ...state,
            serachFor: action.data
        }
  

    case "CHANGE_SORTBY_TRANSACTION_PARAMETERS":
        return{
            ...state,
            sortBy: action.data
            
        }

    case "MAP_TRANSACTION_LIST":
        return{
            ...state,
            transactionList: action.data       
        }

    case "MAP_TRANSACTION_LIST_PAGE_SIZE":
        return{
            ...state,
            pageSize: action.data        
        }

    case "MAP_TRANSACTION_LIST_ACTIVE_PAGE":
        return{
            ...state,
            activePage: action.data        
        }

    case "MAP_TRANSACTION_TOTAL_NUMBER":
        return{
            ...state,
            total_number: action.data
        }
            

    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
